import imageCompression from "browser-image-compression";

// Reject a promise if it doesn't settle in `ms` (used to guard against the
// compression step hanging — seen on Firefox with web-worker webp encoding).
function withTimeout(promise, ms) {
    return new Promise((resolve, reject) => {
        const t = setTimeout(() => reject(new Error("compress timeout")), ms);
        promise.then(
            (v) => { clearTimeout(t); resolve(v); },
            (e) => { clearTimeout(t); reject(e); }
        );
    });
}

function compressImage(file) {
    const originalFile = Promise.resolve(file);

    const options = {
        maxSizeMB: 1,
        maxWidthOrHeight: 1920,
        // Main thread instead of a web worker: worker webp-encoding could hang or
        // crash the tab on Firefox. Compressing one 1920px image on the main
        // thread is quick and reliable across browsers.
        useWebWorker: false,
        maxIteration: 2,
        fileType: 'image/webp',
    }
    const max_skip_size = 0.5 // in MB

    if (file.size / 1024 / 1024 < max_skip_size) {
        // console.log("Skipping compression image to small")
        return originalFile;
    }

    // Never let compression block the upload: on any failure or timeout, fall
    // back to the original file (the server generates webp variants anyway).
    return withTimeout(imageCompression(file, options), 20000)
        .then(function (compressedFile) {
            return compressedFile;
        })
        .catch(function (error) {
            console.log("Compression failed/timed out, uploading original: " + (error && error.message));
            return file;
        });
}

export default compressImage;
